// extracted by mini-css-extract-plugin
module.exports = {"navColor":"var(--themeNavTextColor)","wrap":"TopButton_wrap__3fFxE"};